// extracted by mini-css-extract-plugin
export var buttonSubmit = "section-form-module--buttonSubmit--gps7y";
export var checkboxWrapper = "section-form-module--checkboxWrapper--QI7y6";
export var confirmEmailWrapper = "section-form-module--confirmEmailWrapper--Vsf6-";
export var formContents = "section-form-module--formContents--8rN7m";
export var formTitle = "section-form-module--formTitle--uvHlj typography-module--responsiveTitle2--ySzQe";
export var formWrapper = "section-form-module--formWrapper--PMvG-";
export var phoneWrapper = "section-form-module--phoneWrapper--KDm7c";
export var subHeader = "section-form-module--subHeader--b+423";